import { Addition } from './mathAddition';
import { Common, SimpleGenEq } from '../genHelper';

export class Math_Subtraction__To1000000__Carry extends SimpleGenEq {
  constructor() {
    super(Common.minus(Addition.carry(6)), 'Math_Subtraction__To1000000__Carry');
  }
}

export class Math_Subtraction__To1000000__NoCarry extends SimpleGenEq {
  constructor() {
    super(Common.minus(Addition.noCarry(2, 6)), 'Math_Subtraction__To1000000__NoCarry');
  }
}

export class Math_Subtraction__To10000__Carry extends SimpleGenEq {
  constructor() {
    super(Common.minus(Addition.carry(4)), 'Math_Subtraction__To10000__Carry');
  }
}

export class Math_Subtraction__To1000__Carry extends SimpleGenEq {
  constructor() {
    super(Common.minus(Addition.carry(3)), 'Math_Subtraction__To1000__Carry');
  }
}

export class Math_Subtraction__To1000__NoCarry extends SimpleGenEq {
  constructor() {
    super(Common.minus(Addition.noCarry(2, 3)), 'Math_Subtraction__To1000__NoCarry');
  }
}

export class Math_Subtraction__To100__All extends SimpleGenEq {
  constructor() {
    super(Common.minus(Addition.single(2, 1, 100)), 'Math_Subtraction__To100__All');
  }
}

export class Math_Subtraction__To100__Carry extends SimpleGenEq {
  constructor() {
    super(Common.minus(Addition.carry(2)), 'Math_Subtraction__To100__Carry');
  }
}

export class Math_Subtraction__To100__NoCarry extends SimpleGenEq {
  constructor() {
    super(Common.minus(Addition.noCarry(2, 2)), 'Math_Subtraction__To100__NoCarry');
  }
}

export class Math_Subtraction__To10__All extends SimpleGenEq {
  constructor() {
    super(Common.minus(Addition.single(2, 1, 10)), 'Math_Subtraction__To10__All');
  }
}

export class Math_Subtraction__To20__All extends SimpleGenEq {
  constructor() {
    super(Common.minus(Addition.single(2, 1, 20)), 'Math_Subtraction__To20__All');
  }
}

export class Math_Subtraction__To20__Carry extends SimpleGenEq {
  constructor() {
    super(Common.minus(Addition.carrySingleDigit(20)), 'Math_Subtraction__To20__Carry');
  }
}

export class Math_Subtraction__To5__All extends SimpleGenEq {
  constructor() {
    super(Common.minus(Addition.single(2, 1, 5)), 'Math_Subtraction__To5__All');
  }
}
